import FAQCategory from "../models/FAQCategory";
import FAQSubCategoryMapper from "./FAQSubCategory.mapper";

export default class FAQCategoryMapper {
    public map(data : any) : FAQCategory {
        const faqCategory: FAQCategory = new FAQCategory();
        faqCategory.id = data.Id;
        faqCategory.title = data.Title;
        faqCategory.iconSrc = data.IconSrc;
        faqCategory.anchor = data.Anchor;
        faqCategory.url = data.Url;
        faqCategory.subCategories = data
            .SubCategories
            .map((cat : any) => new FAQSubCategoryMapper().map(cat));
        return faqCategory;
    }
}